import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var createAddActiveInputConnectionToAudioNode = function createAddActiveInputConnectionToAudioNode(insertElementInSet) {
  return function (activeInputs, source, _ref, ignoreDuplicates) {
    var _ref2 = _slicedToArray(_ref, 3),
        output = _ref2[0],
        input = _ref2[1],
        eventListener = _ref2[2];

    insertElementInSet(activeInputs[input], [source, output, eventListener], function (activeInputConnection) {
      return activeInputConnection[0] === source && activeInputConnection[1] === output;
    }, ignoreDuplicates);
  };
};